<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 sm4>
        <agent-editor-configuration-date-format
          :currentFormat="configuration.dateFormat"
          @onSelect="onSelectDateFormat"
          :outlined="outlinedInputs"
        ></agent-editor-configuration-date-format>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field
          type="number"
          label="Quotation Start Days"
          min="0"
          max="999"
          v-model.number="configuration.quotationStartDays"
          @input="onChange"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field
          type="number"
          label="Quotation Max Days"
          min="0"
          max="999"
          v-model.number="configuration.quotationMaxDays"
          @input="onChange"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 sm4>
        <v-text-field
          type="number"
          label="Quotation Max Adults"
          min="0"
          max="999"
          v-model.number="configuration.quotationMaxAdults"
          @input="onChange"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field
          type="number"
          label="Quotation Max Children"
          min="0"
          max="999"
          v-model.number="configuration.quotationMaxChildren"
          @input="onChange"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field
          type="number"
          label="Quotation Max Infants"
          min="0"
          max="999"
          v-model.number="configuration.quotationMaxInfants"
          @input="onChange"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <slot></slot>
    <div v-if="debug">{{configuration}}</div>
  </v-container>
</template>

<script>
import AgentEditorConfigurationDateFormat from "./AgentEditorConfigurationDateFormat";

export default {
  name: "AgentEditorConfiguration",
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    AgentEditorConfigurationDateFormat
  },
  data() {
    return {
      debug: false,
      configuration: { ...this.value }
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    }
  },

  methods: {
    onSelectDateFormat(dateFormat) {
      this.configuration.dateFormat = dateFormat;
      this.$emit("input", { ...this.configuration });
    },
    onChange(event) {
      this.$emit("input", { ...this.configuration });
    }
  },

  watch: {
    value(data) {
      const { __typename, ...configSettings } = data;
      this.configuration = { ...configSettings };
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/gt/agents/AgentEditorConfiguration.vue